import { Injectable } from "@angular/core";
import { IdentityService } from "../../../common/services/identity.service";

const debug = false;

/**
 * This mimics the web app service, especially platform init
 * subscribeUserAgent is a way of putting the new user's address on the app
 * state, so that auth will recognize the user and do signIn
 */

@Injectable({
  providedIn: "root"
})
export class SignUpIdentityService extends IdentityService {
  platformInit(): void {
    debug && console.warn("SignUpIdentityService.platformInit");

    // Enable production mode unless running locally
    if (!document || !document.location) {
      throw new Error("document undefined.");
    }
  }
}
